import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Tag = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m4.17 15.3 4.53 4.53a4.78 4.78 0 0 0 6.75 0l4.39-4.39a4.78 4.78 0 0 0 0-6.75L15.3 4.17a4.75 4.75 0 0 0-3.6-1.39l-5 .24c-2 .09-3.59 1.68-3.69 3.67l-.24 5c-.06 1.35.45 2.66 1.4 3.61'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.7 19.83 4.17 15.3a4.8 4.8 0 0 1-1.4-3.61l.24-5C3.11 4.7 4.7 3.11 6.7 3.02l5-.24a4.75 4.75 0 0 1 3.6 1.39l4.54 4.52a4.78 4.78 0 0 1 0 6.75l-4.39 4.39a4.78 4.78 0 0 1-6.75 0M10 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
